export const keywords = 'diagram|group'.split('|');
export const attributes = 'label|stroke|fill|style|width|opacity|labelposition'.split('|');
